(function () {
  if (window.__bwxQty) return; window.__bwxQty = true;
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2), parts = v.split('.');
    var a = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var b = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (fmt || '€{{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a)
      .replace(/\{\{\s*amount\s*\}\}/, b)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/<[^>]+>/g, '');
  }
  function init(root) {
    if (root.__bwx) return; root.__bwx = true;
    document.body.classList.add('bwx-qty-on');
    var rows = Array.prototype.slice.call(root.querySelectorAll('.bwx-qty__row'));
    var atc = root.querySelector('[data-bwx-qty-atc]');
    var nEl = root.querySelector('[data-bwx-qty-n]');
    var tEl = root.querySelector('[data-bwx-qty-total]');
    var msg = root.querySelector('[data-bwx-qty-msg]');
    var fmt = root.getAttribute('data-money');
    function q(r) { return parseInt(r.querySelector('output').textContent, 10) || 0; }
    function render() {
      var n = 0, tot = 0;
      rows.forEach(function (r) {
        var v = q(r), max = parseInt(r.getAttribute('data-max'), 10) || 0;
        n += v; tot += v * (parseInt(r.getAttribute('data-price'), 10) || 0);
        r.classList.toggle('has-qty', v > 0);
        var b = r.querySelectorAll('button');
        b[0].disabled = v <= 0;
        b[1].disabled = v >= max;
        var m = r.querySelector('.bwx-qty__max'); if (m) m.hidden = !(max > 0 && v >= max);
      });
      nEl.textContent = n;
      tEl.textContent = money(tot, fmt);
      atc.disabled = n === 0;
      atc.textContent = n === 0 ? root.getAttribute('data-t-none') : root.getAttribute('data-t-add').replace('[n]', n);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.bwx-qty__step button'); if (!b || b.disabled) return;
      var r = b.closest('.bwx-qty__row'), max = parseInt(r.getAttribute('data-max'), 10) || 0;
      var v = Math.max(0, Math.min(max, q(r) + parseInt(b.getAttribute('data-d'), 10)));
      r.querySelector('output').textContent = v; msg.textContent = ''; msg.classList.remove('is-err');
      render();
    });
    atc.addEventListener('click', function () {
      var items = rows.filter(function (r) { return q(r) > 0; }).map(function (r) { return { id: parseInt(r.getAttribute('data-id'), 10), quantity: q(r) }; });
      if (!items.length) return;
      atc.disabled = true; atc.textContent = root.getAttribute('data-t-adding');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'error');
          var s = res.j.sections || {};
          Object.keys(s).forEach(function (k) {
            if (!s[k]) return;
            var doc = new DOMParser().parseFromString(s[k], 'text/html');
            var target = document.getElementById(k) || document.getElementById('shopify-section-' + k);
            var fresh = doc.getElementById(k) || doc.querySelector('.shopify-section') || doc.body.firstElementChild;
            if (!target || !fresh) return;
            if (fresh.id && fresh.id === target.id) target.replaceWith(fresh); else target.innerHTML = fresh.innerHTML;
          });
          rows.forEach(function (r) { r.querySelector('output').textContent = 0; });
          render();
          msg.textContent = root.getAttribute('data-t-added');
          var ws = window.WhatSub, fire = ws && (ws.dispatch || ws.publish);
          if (fire) { try { fire.call(ws, 'CART_UPDATE'); fire.call(ws, 'ADD_TO_CART'); } catch (e) {} }
          else { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }
        })
        .catch(function (err) {
          msg.textContent = (err && err.message && err.message !== 'error') ? err.message : root.getAttribute('data-t-err');
          msg.classList.add('is-err');
          render();
        });
    });
    render();
  }
  function boot() { document.querySelectorAll('[data-bwx-qty]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
